export interface IHoleScore {
  game: number;
  gross: number;
  grossStableford?: number;
  handicap: number;
  holeHandicap: number;
  holePar: number;
  id: number;
  net: number;
  netStableford?: number;
  order: number;
  original: number;
  pinDistance?: string | null;
}

export interface IScore {
  enrollment: number;
  grossScore: number;
  group: number;
  handicap: number;
  id: number;
  netScore?: number;
  qualified: boolean;
  round: number;
  scores: IHoleScore[];
  seat: number;
  status: string;
}

export interface IScoresStore {
  [groupId: number]: IScore[];
}

export const scoresStore: IScoresStore = {};
